import React from 'react';

function Project() {
  return (
    <section className="sec-box main-post section-padding">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="caption text-center">
            <div className="gat">
              <a href="#0">
                <span>Web Design</span>
              </a>
              <a href="#0">
                <span>Envato</span>
              </a>
            </div>
            <h1 className="fz-55 mt-30">
              Network of wormholes colonies extraordinary claims require.
            </h1>
            <p className="sub-title mt-15">6 , August 2022 - By Admin</p>
          </div>
          <div className="main-img mb-80 mt-40">
            <img src="/assets/imgs/blog/m.jpg" alt="" className="radius-5" />
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-9">
          <div className="cont">
            <div className="text mb-20">
              <div className="d-flex align-items-center mb-20">
                <span className="fz-60 fw-500 main-color line-height-1 mr-10">
                  A
                </span>
                <p>
                  new report said earlier this week that Apple is working on a
                  brand new laptop. A trusted Apple insider with a proven track
                  record confirmed that Apple is working on the larger MacBook
                  Air.
                </p>
              </div>
              <p>
                new report said earlier this week that Apple is working on a
                brand new laptop. Apple plans to release a 15-inch MacBook Air
                in 2024, a first for the Air series. A trusted Apple insider
                with a proven track record confirmed that Apple is working on
                the larger MacBook Air.
              </p>
            </div>
            <div className="text">
              <p>
                However, Apple might not include it in the Air series when it
                launches it. As for the notebook’s release date, the 15-inch
                MacBook isn’t coming soon. It’ll get a late 2024 release at
                best, according to the new claims.
              </p>
            </div>
            <div className="title mt-30">
              <h5 className="fw-500">What sizes do MacBook Airs come in?</h5>
            </div>
            <div className="text mt-20">
              <p>
                Apple currently sells only one MacBook Air size. The laptop
                comes in a 13-inch version that matches the pre-2021 13-inch
                MacBook Pro size. Previously, Apple sold an 11-inch MacBook Air,
                but the company discontinued that model in 2017.
              </p>
            </div>
            <div className="post-qoute mt-50">
              <h6 className="line-height-28 fz-20">
                <span className="l-block">
                  Increase your site traffic and gain new customers with a
                  beautiful and functional blog.
                </span>
                <span className="sub-title main-color mt-20 mb-0">
                  {' '}
                  - UICamp Code
                </span>
              </h6>
            </div>
            <div className="mb-50 mt-50">
              <div className="row">
                <div className="col-sm-6">
                  <div className="iner-img sm-mb30">
                    <img src="/assets/imgs/blog/b1.jpg" alt="" />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="iner-img">
                    <img src="/assets/imgs/blog/b2.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="title mb-10">
              <h5 className="fw-500">
                Apple currently sells only one MacBook Air size.
              </h5>
            </div>
            <div className="text mb-20">
              <p>
                A new report said earlier this week that Apple is working on a
                brand new laptop. Apple plans to release a 15-inch MacBook Air
                in 2024, a first for the Air series. A trusted Apple insider
                with a proven track record confirmed that Apple is working on
                the larger MacBook Air.
              </p>
            </div>
            <div className="unorder-list mb-30">
              <h6 className="mb-10">Ordered & Unordered Lists.</h6>
              <ul className="rest">
                <li>Yet this above sewed flirted opened ouch</li>
                <li>Goldfinch realistic sporadic ingenuous</li>
                <li>
                  Abominable this abidin far successfully then like piquan
                </li>
              </ul>
            </div>
            <div className="order-list mb-30">
              <h6 className="mb-10">Ordered & Unordered Lists.</h6>
              <ul className="rest">
                <li>
                  <span>01 -</span> Yet this above sewed flirted opened ouch
                </li>
                <li>
                  <span>02 -</span> Goldfinch realistic sporadic ingenuous
                </li>
                <li>
                  <span>03 -</span> Abominable this abidin far successfully then
                  like piquan
                </li>
              </ul>
            </div>
            <div className="text">
              <p>
                However, Apple might not include it in the Air series when it
                launches it. As for the notebook’s release date, the 15-inch
                MacBook isn’t coming soon. It’ll get a late 2024 release at
                best, according to the new claims.
              </p>
            </div>

            <div className="info-area flex mt-20 pb-20 pt-20 bord-thin-top bord-thin-bottom">
              <div>
                <div className="tags flex">
                  <div className="valign">
                    <span>Tags :</span>
                  </div>
                  <div>
                    <a href="#">Tech</a>
                    <a href="#">Gavi</a>
                  </div>
                </div>
              </div>
              <div className="ml-auto">
                <div className="share-icon flex">
                  <div className="valign">
                    <span>Share :</span>
                  </div>
                  <div>
                    <a href="https://www.facebook.com/">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.twitter.com/">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.youtube.com/">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="author-area mt-50">
              <div className="flex">
                <div className="author-img mr-30">
                  <div className="img">
                    <img
                      src="/assets/imgs/blog/author1.jpg"
                      alt=""
                      className="circle-img"
                    />
                  </div>
                </div>
                <div className="cont valign">
                  <div className="full-width">
                    <h6 className="fw-500 mb-10">Chris Smith</h6>
                    <p>
                      Nulla eleifend, lectus eu gravida facilisis, ipsum metus
                      faucibus eros, vitae vulputate nibh libero ac metus.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="next-prv-post flex mt-50">
              <div
                className="thumb-post bg-img"
                data-background="assets/imgs/blog/1.jpg"
              >
                <a href="single-blog">
                  <span className="fz-12 text-u ls1 main-color mb-15">
                    <i className="pe-7s-angle-left"></i>
                    Prev Post
                  </span>
                  <h6 className="fw-500 fz-16">
                    Ways to quickly traffic to <br /> your website.
                  </h6>
                </a>
              </div>
              <div
                className="thumb-post ml-auto text-right bg-img"
                data-background="assets/imgs/blog/2.jpg"
              >
                <a href="single-blog">
                  <span className="fz-12 text-u ls1 main-color mb-15">
                    Next Post <i className="pe-7s-angle-right"></i>
                  </span>
                  <h6 className="fw-500 fz-16">
                    How to Handle Your Good Employee.
                  </h6>
                </a>
              </div>
            </div>

            <div className="comments-post section-padding">
              <div className="sec-head mb-60">
                <h5>comments (2)</h5>
              </div>
              <div className="item-box bord-thin-bottom pb-30 mb-30">
                <div className="flex">
                  <div className="user-img mr-30">
                    <div className="img circle-60 line-height-1">
                      <img
                        src="/assets/imgs/blog/author1.jpg"
                        alt=""
                        className="circle-img"
                      />
                    </div>
                  </div>
                  <div className="cont">
                    <h6 className="mb-10">Megan fox</h6>
                    <p>
                      Ut elementum turpis lorem, id vulputate risus consequat
                      vitae. Morbi eget urna imperdiet, pellentesque nulla id,
                      tempus mauris.
                    </p>
                  </div>
                </div>
                <div className="replay-butn">
                  <a href="#0">
                    <span>Replay</span>
                  </a>
                </div>
              </div>
              <div className="item-box replayed">
                <div className="flex">
                  <div className="user-img mr-30">
                    <div className="img circle-60 line-height-1">
                      <img
                        src="/assets/imgs/blog/author1.jpg"
                        alt=""
                        className="circle-img"
                      />
                    </div>
                  </div>
                  <div className="cont">
                    <h6 className="mb-10">Megan fox</h6>
                    <p>
                      Ut elementum turpis lorem Morbi eget urna imperdiet,
                      pellentesque nulla id, tempus mauris.
                    </p>
                  </div>
                </div>
                <div className="replay-butn">
                  <a href="#0">
                    <span>Replay</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="comments-from">
              <div className="sec-head mb-60">
                <h5>Leave a comment</h5>
              </div>
              <form id="contact-form" method="post" action="contact.php">
                <div className="messages"></div>

                <div className="controls row">
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <input
                        id="form_name"
                        type="text"
                        name="name"
                        placeholder="Name"
                        required="required"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <input
                        id="form_email"
                        type="email"
                        name="email"
                        placeholder="Email"
                        required="required"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-30">
                      <textarea
                        id="form_message"
                        name="message"
                        placeholder="Message"
                        rows="4"
                        required="required"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-12 text-center mt-20">
                    <button type="submit">
                      <span className="text">Post comment</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Project;
